import { Pipe, PipeTransform } from '@angular/core';

import { IOfficeField } from '@pages/office/models/office-data.model';
import { FormFieldHelper } from '@pages/office/shared/helpers/form-field.helper';
import { FormFieldControlType } from '../../../../models/office-form.model';

@Pipe({
  name: 'filedControlType',
  standalone: true,
})
export class FiledControlTypePipe implements PipeTransform {
  transform(type: IOfficeField['WebInputType']): FormFieldControlType {
    return FormFieldHelper.getControlTypeByWebInputType(type);
  }
}
